import request from '@/utils/request'

// 开票列表
export function invoiceList(params) {
  return request({ url: '/webapi/index/invoiceList', method: 'get', params })
}

// 获取可开票金额
export function invoiceMoney(params) {
  return request({ url: '/webapi/index/invoiceMoney', method: 'get', params })
}

// 获取发票信息
export function getInvoiceInfo() {
  return request({ url: '/webapi/index/getInvoiceInfo', method: 'get' })
}

// 添加 or 更新发票信息
export function addOrUpdateInvoiceInfo(data) {
  return request({ url: '/webapi/index/addOrUpdateInvoiceInfo', method: 'post', data })
}

// 获取发票地址
export function getInvoiceAddress() {
  return request({ url: '/webapi/index/getInvoiceAddress', method: 'get' })
}

// 添加 or 更新收票地址管理
export function addOrUpdateInvoiceAddress(data) {
  return request({ url: '/webapi/index/addOrUpdateInvoiceAddress', method: 'post', data })
}

// 获取省市区列表
export function regionList() {
  return request({ url: '/webapi/common/regionList', method: 'get' })
}

// 申请开票接口
export function runInvoice(data) {
  return request({ url: '/webapi/index/runInvoice', method: 'post', data })
}

// 待对账列表
export function waitInvoice(data) {
  return request({ url: '/webapi/invoicenew/waitReconciliation', method: 'post', data })
}

// 发起对账单
export function sendInvoice(data) {
  return request({ url: '/webapi/invoicenew/sendReconciliation', method: 'post', data })
}

// 对账中列表
export function inInvoice(data) {
  return request({ url: '/webapi/invoicenew/inReconciliation', method: 'post', data })
}

// 上传一般纳税人文件
export function uploadTaxpayer(data) {
  return request({ url: '/webapi/company/uploadTaxpayer', method: 'post', data })
}

// 签署对账单
export function signInvoice(data) {
  return request({ url: '/webapi/invoicenew/signSettlement', method: 'post', data })
}

// 撤销对账单
export function revokeInvoice(data) {
  return request({ url: '/webapi/invoicenew/revoke', method: 'post', data })
}

// 拒绝对账单
export function refuseInvoice(data) {
  return request({ url: '/webapi/invoicenew/refuse', method: 'post', data })
}

// 对账中列表
export function overInvoice(data) {
  return request({ url: '/webapi/invoicenew/overReconciliation', method: 'post', data })
}

// 作废列表
export function tovoidInvoice(data) {
  return request({ url: '/webapi/invoicenew/tovoidReconciliation', method: 'post', data })
}

// 修改结束日期获取对账金额
export function enddayRecon(data) {
  return request({ url: '/webapi/invoicenew/enddayRecon', method: 'post', data })
}

// 获取合同编号
export function getInvoiceNumber(data) {
  return request({ url: '/webapi/invoicenew/getcontractNumber', method: 'post', data })
}

// 手动更新待对账列表
export function updatewaitRecon(data) {
  return request({ url: '/webapi/invoicenew/updatewaitRecon', method: 'post', data })
}

// 手动更新发票管理数据
export function updateInvoicesummary(data) {
  return request({ url: '/webapi/invoicenew/updateInvoicesummary', method: 'post', data })
}

// 开票记录列表
export function summaryInvoice(data) {
  return request({ url: '/webapi/invoicenew/invoiceSummary', method: 'post', data })
}

// 开票详情
export function invoiceDetail(data) {
  return request({ url: '/webapi/invoicenew/invoiceDetail', method: 'post', data })
}

// 开票信息
export function getInvioceinfo(data) {
  return request({ url: '/webapi/invoicenew/getInvioceinfo', method: 'post', data })
}

// 开票详情
export function invoiceInfo(data) {
  return request({ url: '/webapi/invoicenew/invoiceInfo', method: 'post', data })
}

// 可授权列表
export function adminList(data) {
  return request({ url: '/webapi/seal/adminList', method: 'post', data })
}

// 添加授权
export function sealAdd(data) {
  return request({ url: '/webapi/seal/sealAdd', method: 'post', data })
}

// 已授权列表
export function sealList(data) {
  return request({ url: '/webapi/seal/sealList', method: 'post', data })
}

// 删除授权
export function sealDel(data) {
  return request({ url: '/webapi/seal/sealDel', method: 'post', data })
}

// 获取企业印章
export function getSeal(params) {
  return request({ url: '/webapi/esign/getSeal', method: 'get', params })
}

// 创建机构账号
export function orgAccountCreate(data) {
  return request({ url: '/webapi/esign/orgAccountCreate', method: 'post', data })
}

